import React, { useEffect, useState } from "react";
import LiquidateNewCard from "./components/LiquidateNewCard";
import { useSelector } from "react-redux";

const Liquidate = () => {

  const [query, setQuery] = useState("");

  
  // TMD console.log( 'SAMEER --------- LIQUIDATE--------');
  const positionList = useSelector((state) => {
        let items = [];
        if (state.coins.kraken_asset_pairs !== undefined) {
          state.coins.kraken_asset_pairs.forEach((item) => {
            if ( item !== undefined && item.position !== undefined) 
            {
                // TMD console.log( item);
                if (item.position.invested > 1)
                {
                    // TMD console.log( 'LIQUIDATE: pos: ' + JSON.stringify(item.position));
                    items.push(item);
                }
            }
          });
        }
        return items;
      });

  let filtered = [];
  positionList
    .filter((post) => {
      if (query === "") {
        return post;
      } else if (post === undefined) {
        return post;
      } else if (post.coin_name.toLowerCase().includes(query.toLowerCase())) {
        return post;
      }
    })
    .map((post, index) => {
      filtered.push(post);
  });

  return <LiquidateNewCard title="Liquidate" rows={filtered} />;
};

export default React.memo(Liquidate);
